import React, { Component } from 'react';
import styled from 'styled-components';
import _ from 'lodash';


/**
* styled components
*/
const SuggestionsContainer = styled.div`
  h2 {
    text-transform: uppercase;
    margin-top:0;
  }
`;

const ObservationContainer = styled.div`
  p {
    margin-bottom: 0;
  }
`;

const TagSuggestions = styled.div``;

const TagSuggestion = styled.span`
  margin-right: 10px !important;
  border-radius: 10px !important;
  padding: 5px 8px !important;
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 500;
`;


/**
* Class Suggestions
*/
class Suggestions extends Component {
  renderObservation(data) {
    return(
      <ObservationContainer>
        <p className="small-font-size">From analysing the key outakes from <span className="report-tag tiny-font-size">{data.observation.property}</span> we should work on the following areas:</p>
        {data.suggestion.property}
        {this.renderSuggestions(data.suggestions.property)}
      </ObservationContainer>
    )
  }

  renderSuggestions(suggestions) {
    return(

      <TagSuggestions>
      {
        _.map(suggestions, (suggestion, index) => {
          return(
            <TagSuggestion key={`suggestiontag-${suggestion}-${index}`} className="tiny-font-size report-tag">{suggestion}</TagSuggestion>
          );
        })
      }
      </TagSuggestions>

    )
  }

  render() {
    const { data } = this.props;

    return(
      <SuggestionsContainer>
        {data.title ? <h2 className="normal-font-size">{data.title}</h2> : ''}
        {this.renderObservation(data)}
      </SuggestionsContainer>
    );
  }
}

export default Suggestions;



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/Suggestions.js